import Utils from "platform/util/Utils";

enum Currency {

    EUR = "EUR",
    USD = "USD",
    PLN = "PLN",
}

namespace Currency {

    export function sign(v: string): string {
        if (Utils.isNotEmpty(v)) {
            switch (v.toUpperCase()) {
                case "EUR":
                    return "€";
                case "USD":
                    return "$";
                case "PLN":
                    return "zł";
            }
        }
        return "";
    }
}

export {
    Currency
};
